import { AxiosRequestConfig } from "axios";
import { AUTOMACAO_HEADER_CNPJ, AUTOMACAO_HEADER_token } from "@/commons/config";

export const biometriaHandleRequest = (config: AxiosRequestConfig) => {
  config.headers = {
    ...config.headers,
    Accept: "application/json",
    "Content-Type": "application/json",
    "cnpj": AUTOMACAO_HEADER_CNPJ,
    "token": AUTOMACAO_HEADER_token
  };

  return config;
};

export const biometriaHandleErrorRequest = (error: any) =>
  Promise.reject(error);
